// 支持站点（SiteGrid）数据源：站点名走 i18n（sites.<key>.name，三语适配界面语言），
// logo 路径与 key 由本 composable 统一维护，Home / About 共用，消除两处硬编码重复。
// 站点集合与扩展端 config/sites.json 对齐（扩展端站点名按官方品牌展示）。

import { useI18n } from 'vue-i18n'

export interface SupportedSiteItem {
  name: string
  key: string
  image: string
}

const SITE_IMAGES: Record<string, string> = {
  migu: '/icons/sites/migu.png',
  iqiyi: '/icons/sites/iqiyi.png',
  bilibili: '/icons/sites/bilibili.png',
  cctv: '/icons/sites/cctv.png',
  yangshipin: '/icons/sites/yangshipin.png',
  tencent: '/icons/sites/tencent.png',
  douyin: '/icons/sites/douyin.png',
  weibo: '/icons/sites/weibo.png',
  xiaohongshu: '/icons/sites/xiaohongshu.png'
}

export const SUPPORTED_SITE_KEYS = Object.keys(SITE_IMAGES)

export function useSupportedSites(): SupportedSiteItem[] {
  const { t } = useI18n()
  return SUPPORTED_SITE_KEYS.map((key) => ({
    key,
    name: t(`sites.${key}.name`),
    image: SITE_IMAGES[key]
  }))
}
